<template lang="pug">
  router-link(:to="to")
    slot
</template>

<script>
export default {
  name: 'BaseLink',
  props: {
    to: Object,
  },
};
</script>

<style scoped lang="scss">
  a {
    transition: color 0.3s;
    &:hover {
      color: #33A1FB;
    }
  }
</style>
